import axios from "@/libs/api.request";
// 获取列表
export const getHwBill = data => {
  return axios.request({
    url: "/finance/hq/hw/bill/index",
    method: "post",
    data
  });
};
export const getDetails = data => {
  return axios.request({
    url: `/finance/overseas/bill/read/${data.id}`,
    method: "post",
    data
  });
};

export const exportDetails = id => {
  return axios.request({
    url: `/finance/overseas/bill/exportDetail/${id}`,
    method: "post"
  });
};

export const resetHwAmount = id => {
  return axios.request({
    url: `/finance/hq/hw/bill/recalculate/${id}`,
    method: "post"
  });
};

export const getHwBillClient = params => {
  return axios.request({
    url: `/finance/hq/hw/bill/queryBillUsers`,
    method: "get",
    params
  });
};

export const saveHwBill = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/createBill`,
    method: "post",
    data
  });
};

export const delHwBill = id => {
  return axios.request({
    url: `/finance/hq/hw/bill/del/${id}`,
    method: "delete"
  });
};

export const updateHwBill = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/update/${data.id}`,
    method: "post",
    data
  });
};

export const confirmBill = id => {
  return axios.request({
    url: `/finance/hq/hw/bill/confirm/${id}`,
    method: "post"
  });
};

export const auditBill = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/audit/${data.id}`,
    method: "post",
    data
  });
};

export const appendCnbNo = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/append/${data.id}`,
    method: "post",
    data
  });
};

export const getBillClients = id => {
  return axios.request({
    url: `/finance/overseas/bill/clients/${id}`,
    method: "get"
  });
};
export const exportAllBill = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/outAnalyze`,
    method: "post",
    data
  });
};

export const hangBill = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/setException/${data.id}`,
    method: "post",
    data
  });
};

export const deleteDetails = data => {
  return axios.request({
    url: `/finance/hq/hw/bill/removeDetail/${data.id}`,
    method: "post",
    data
  });
};

export const hwDoHedge = data => {
  return axios.request({
    url: `/finance/hedge/hwDoHedge`,
    method: "post",
    data
  });
};


export const sync = () =>{
	return axios.request({
	  url: `/finance/hq/hw/bill/sync`,
	  method: "get",
	});
}